import { RequestAccessButton } from './RequestAccessButton';
export function LandingCta() {
  return (
    <>
      <section className="wf-section wf-teams" id="early-access">
        <h2>
          Built for the operators,
          <br />
          not their slide decks.
        </h2>
        <ul className="wf-team-list">
          <li>Film distributors</li>
          <li>Labels &amp; music publishers</li>
          <li>Distribution &amp; sales agents</li>
          <li>Rights &amp; royalties teams</li>
        </ul>
        <div className="wf-two-columns">
          <div>
            <h2>Built for real distribution workflows.</h2>
            <RequestAccessButton />
          </div>
          <ul>
            <li>Review the terms that drive every payment</li>
            <li>Keep sales, costs and participants in the same workflow</li>
            <li>Calculate shares across multiple reporting levels</li>
            <li>Approve and export statements for counterparties</li>
          </ul>
        </div>
      </section>
      <section className="wf-cta">
        <h2>
          Help shape the next standard for
          <br /> royalty reporting.
        </h2>
        <p>
          We&apos;re onboarding finance and business-affairs teams to validate workflows, pricing,
          and outputs.
        </p>
        <RequestAccessButton size="lg" />
      </section>
    </>
  );
}
